import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  wrapperModal: {
    [theme.breakpoints.down('md')]: {
      padding: '0px',
    },
  },
  modalWindow: {
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-end',
    },
  },
  wrapperContent: (props: any) => ({
    padding: '21px 30px',
    borderRadius: '8px',
    backgroundColor: props.filterBackgroundColor,
    [theme.breakpoints.down('md')]: {
      borderRadius: '20px 20px 0px 0px',
      margin: 'unset',
    },
    '& .image-gallery-slides': {
      borderRadius: '8px',
    },
    '& .image-gallery-fullscreen-button': {
      right: '15px',
      bottom: '15px',
    },
  }),
  iframeWrapperContent: {
    maxWidth: '1130px',
    height: '100%',
    maxHeight: '688px',
    padding: '32px',
    [theme.breakpoints.down('md')]: {
      padding: 0,
      borderRadius: 0,
      margin: 'unset',
      '&& .header': {
        display: 'none',
        zIndex: 1,
      },
      '&& .content': {
        zIndex: 0,
      },
    },
  },
  closeButton: {
    top: '13px',
    backgroundColor: 'unset',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
}));
